import { render, staticRenderFns } from "./higher-search.vue?vue&type=template&id=7c24fc1d&scoped=true&"
import script from "./higher-search.vue?vue&type=script&lang=js&"
export * from "./higher-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c24fc1d",
  null
  
)

export default component.exports